// ++underline++

// Insert each marker as a separate text token, and add it to delimiter list
function tokenize(state, silent) {
	let i
	let token
	let len
	const start = state.pos
	const marker = state.src.charCodeAt(start)

	if (silent) { return false }
	if (marker !== 0x2B/* + */) { return false }

	const scanned = state.scanDelims(state.pos, true)
	len = scanned.length
	const ch = String.fromCharCode(marker)

	if (len < 2) { return false }

	if (len % 2) {
		token = state.push('text', '', 0)
		token.content = ch
		len--
	}

	for (i = 0; i < len; i += 2) {
		token = state.push('text', '', 0)
		token.content = ch + ch

		state.delimiters.push({
			marker,
			length: 0, // disable "rule of 3" length checks meant for emphasis
			jump: i / 2, // for `++` 1 marker = 2 characters
			token: state.tokens.length - 1,
			end: -1,
			open: scanned.can_open,
			close: scanned.can_close,
		})
	}

	state.pos += scanned.length

	return true
}

function executePostProcess(state, delimiters) {
	let i
	let j
	let startDelim
	let endDelim
	let token
	const loneMarkers = []
	const max = delimiters.length

	for (i = 0; i < max; i++) {
		startDelim = delimiters[i]

		if (startDelim.marker !== 0x2B/* + */) {
			// eslint-disable-next-line no-continue
			continue
		}

		if (startDelim.end === -1) {
			// eslint-disable-next-line no-continue
			continue
		}

		endDelim = delimiters[startDelim.end]

		token = state.tokens[startDelim.token]
		token.type = 'underline_open'
		token.tag = 'u'
		token.nesting = 1
		token.markup = '++'
		token.content = ''

		token = state.tokens[endDelim.token]
		token.type = 'underline_close'
		token.tag = 'u'
		token.nesting = -1
		token.markup = '++'
		token.content = ''

		if (state.tokens[endDelim.token - 1].type === 'text'
			&& state.tokens[endDelim.token - 1].content === '+') {
			loneMarkers.push(endDelim.token - 1)
		}
	}

	// If a marker sequence has an odd number of characters, it's splitted
	// like this: `++++++++++` -> `++` + `++++` + `++++`, leaving one marker at the
	// start of the sequence.
	//
	// So, we have to move all those markers after subsequent u_close tags.
	//
	while (loneMarkers.length) {
		i = loneMarkers.pop()
		j = i + 1

		while (j < state.tokens.length && state.tokens[j].type === 'underline_close') {
			j++
		}

		j--

		if (i !== j) {
			token = state.tokens[j]
			state.tokens[j] = state.tokens[i]
			state.tokens[i] = token
		}
	}
}

// Walk through delimiter list and replace text tokens with tags
function postProcess(state) {
	let curr
	const tokensMeta = state.tokens_meta
	const max = state.tokens_meta.length

	executePostProcess(state, state.delimiters)

	for (curr = 0; curr < max; curr++) {
		if (tokensMeta[curr] && tokensMeta[curr].delimiters) {
			executePostProcess(state, tokensMeta[curr].delimiters)
		}
	}
}

export default (md) => {
	md.inline.ruler.before('emphasis', 'underline', tokenize)
	md.inline.ruler2.before('emphasis', 'underline', postProcess)
}
